import React, { useRef, useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Link, useStaticQuery, graphql, StaticQuery } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import styled from "styled-components"
import { LayoutGroup, motion } from "framer-motion"
import { useBoundingclientrect, useBoundingclientrectRef } from "rooks"
import GridImage from "./gridImage"

const ImageGridStyles = styled.div`
  width: 100%;
  @media (min-width: 768px) {
    width: 100%;
  }
  margin: 100px auto;
  padding: 0 10vw;
  z-index: 10;
  position: relative;
  margin: 200px 0;
`

const GridWrap = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
  }
  @media (min-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }

  grid-auto-rows: minmax(min-content, max-content);
`
const GridImageWrap = styled.div`
  &:nth-child(2n) {
    margin-top: 0;
  }
  @media (min-width: 1200px) {
    &:nth-child(2n) {
      margin-top: 30vh;
    }
  }
`

export default function Grid({ personal, personalEdges }) {
  //state of selected item
  const [isSelected, setIsSelected] = useState(null)
  const [isSelectedBool, setIsSelectedBool] = useState(false)
  //handle selected change
  function handleChange(SelectID) {
    setIsSelected(SelectID)
    setIsSelectedBool(true)
  }
  /*
  const { images } = useStaticQuery(
    graphql`
      query {
        images: allFile(
          filter: {
            extension: { regex: "/(jpg)|(png)|(jpeg)/" }
            sourceInstanceName: { eq: "personalimages" }
          }
        ) {
          edges {
            node {
              id
              name
              base
              childImageSharp {
                gatsbyImageData(
                  placeholder: BLURRED
                  layout: FULL_WIDTH
                  width: 1400
                  breakpoints: [750, 1080, 1366, 1920]
                )
              }
            }
          }
        }
      }
    `
  )
*/
  const container = {
    hidden: { opacity: 1 },
    show: {
      opacity: 1,
      transition: {
        delayChildren: 0.2,
        staggerChildren: 0.1,
      },
    },
  }

  const item = {
    hidden: { opacity: 0, y: 0 },
    show: { opacity: 1, y: 0 },
  }

  return (
    <ImageGridStyles>
      <LayoutGroup id="images">
        <GridWrap
          as={motion.div}
          variants={container}
          initial="hidden"
          animate="show"
        >
          {personal.map((personalItem, i) => (
            <GridImageWrap
              as={motion.div}
              variants={item}
              transition={{ duration: 0.5, ease: [0.43, 0.13, 0.23, 0.96] }}
            >
              <GridImage
                id={i}
                data-scroll-speed={Math.floor(Math.random() * (3 + 1))}
                image={personalItem.image}
                selected={isSelected == i ? "selected" : null}
                selectedOne={isSelectedBool}
                onChange={handleChange}
                url={personalItem.slug.current}
              />
            </GridImageWrap>
          ))}
        </GridWrap>
      </LayoutGroup>
    </ImageGridStyles>
  )
}
